// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/analytics'
// import './plugins/element.js'
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faAt } from '@fortawesome/free-solid-svg-icons'
// import { faGithub, faTrello, faWindows } from '@fortawesome/free-brands-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.config.productionTip = false

let app = ''

const config = {
  apiKey: process.env.FIREBASE_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DB_DOMAIN,
  projectId: process.env.FIREBASE_ID,
  storageBucket: process.env.FIREBASE_STORE_DOMAIN,
  messagingSenderId: process.env.FIREBASE_MESSAGE_ID,
  appId: '1:134522336002:web:91d88ecb27a6d63318481b',
  measurementId: process.env.FIREBASE_MEASUREMENT_ID
}

firebase.initializeApp(config)
firebase.analytics()

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !currentUser) next('/')
  else next()
})

// library.add(faAt, faGithub, faTrello, faWindows)

// Vue.component('font-awesome-icon', FontAwesomeIcon)

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js